import { render, staticRenderFns } from "./AIAvatarBackgroundSelectionPanel.vue?vue&type=template&id=2dab8713&scoped=true"
import script from "./AIAvatarBackgroundSelectionPanel.vue?vue&type=script&lang=ts"
export * from "./AIAvatarBackgroundSelectionPanel.vue?vue&type=script&lang=ts"
import style0 from "./AIAvatarBackgroundSelectionPanel.vue?vue&type=style&index=0&id=2dab8713&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dab8713",
  null
  
)

export default component.exports